export default __webpack_public_path__ + "static/media/drone.129e62f3.gif";